import { AxiosRequestConfig } from 'axios';

// import { axiosInterceptors } from './request-wrapper';

// axiosInterceptors.request.use((config) => {
//   const authorizationCallback = () => {
//     if (isAuthenticationEnabled && userService.isLoggedIn()) {
//       config.headers.Authorization = `Bearer ${userService.getToken()}`;
//     }
//     return Promise.resolve(config);
//   };
//   return userService.updateToken(authorizationCallback);
// });

export const requestConfig = ({ ...options }: AxiosRequestConfig): AxiosRequestConfig => {
  // add any options, headers to request config, e.g. bearer to request
  // EX: {...options, headers: { Authorization: `Bearer: ${token}`}}

  return { ...options };
};

export default requestConfig;
